module.exports = __webpack_public_path__ + "img/art9.d9f046ed.png";